export default "__VITE_ASSET__59d72aed__"